import { Link } from 'react-router-dom';

import styles from './CommunityCell.module.css';

export const CommunityCell = ({
  image,
  title,
  href,
  isOffset = false,
}: {
  image: string;
  title: string;
  href: string;
  isOffset?: boolean;
}) => {
  const content = (
    <>
      <div className={styles.bottomOverlay} />
      <div className={styles.bottomLines} />
      <div className={styles.communityCellInner}>
        <p className={styles.communityCellName}>{title}</p>
        <div className={styles.communityCellOverlay} />
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img className={styles.communityCellImg} src={image} />
      </div>
    </>
  );

  const className = isOffset
    ? styles.communityCellOffCenter
    : styles.communityCell;

  if (/^https?:\/\//.test(href)) {
    return (
      <a href={href} className={className}>
        {content}
      </a>
    );
  }

  return (
    <Link to={href} className={className}>
      {content}
    </Link>
  );
};
